import CwPptPreview from "./index.vue"

export default CwPptPreview